import { Accordion } from "@gcs/design-system/react";
import styled from "styled-components";

const variantStyles = (theme, variant, isActiveTab) =>
  ({
    primary: {
      minWidth: "150px",
      borderRadius: "8px",
      background: isActiveTab ? theme.color.brandPrimary.light : "transparent",
      padding: "8px 20px",
      border: !isActiveTab ? "none" : `1px solid ${theme.color.line.medium}`,

      color: isActiveTab
        ? theme.color.neutral["08"]
        : theme.color.brandPrimary.light,

      [theme.breakpoint.xl()]: {
        fontSize: "18px",
        minWidth: "196px",
      },
    },
    secondary: {
      flex: 1,
      background: "transparent",
      border: "none",
      padding: "16px 8px",
      fontWeight: "700",
      borderBottom: isActiveTab
        ? `4px solid ${theme.color.brandSecondary.light}`
        : `2px solid ${theme.color.line.medium}`,

      [theme.breakpoint.xl()]: {
        fontSize: "18px",
        paddingTop: "32px",
        paddingBottom: isActiveTab ? "32px" : "34px",
      },
    },
  }[variant]);

export const TabsContainer = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "60px",
}));

export const TabsList = styled.div(({ theme, $variant }) => ({
  margin: $variant === "primary" ? "0 auto" : "0",
  width: $variant === "primary" ? "fit-content" : "inherit",
  gap: $variant === "primary" ? "0" : "27px",
  border:
    $variant === "primary" ? `1px solid ${theme.color.line.medium}` : "none",
  borderRadius: "8px",

  display: "flex",
  justifyContent: "center",
  overflowX: "auto",
}));

export const TabsTrigger = styled.button(
  ({ theme, $isActiveTab, $variant }) => ({
    ...variantStyles(theme, $variant, $isActiveTab),
    flex: 1,
    cursor: "pointer",
    transition: "all .1s ease-in-out",
  })
);

export const TabsAccordion = styled(Accordion.Item)(({ theme }) => ({
  "[class^='Accordionstyle__Head-']": {
    color: theme.color.brandPrimary.light,
  },

  p: {
    fontSize: "18px",
  },
}));

export const TabsAccordionContent = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
}));
